import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage, successMessage } from "../../../utlis/common";
import { SOME_WENT_WRONG } from "../../../utlis/messages";

const INTEGRATION_STATUS = `integration/status`;
const INTEGRATION_INITIATE = `integration/initiate`;
const INTEGRATION_DISCONNECT = `integration/disconnect`;
const INTEGRATION_INVENTORY_SYNC = `integration/inventory-sync`;
const INTEGRATION_SYNC_NOW = `integration/sync-now`;

export const getIntegrationStatus = createAsyncThunk(
  "integration/getStatus",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await customAxios("application/json", dispatch).get(
        INTEGRATION_STATUS
      );
      return response.data?.data;
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data?.responseMessage || SOME_WENT_WRONG
      );
    }
  }
);

export const initiateIntegration = createAsyncThunk(
  "integration/initiate",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await customAxios("application/json", dispatch).get(
        INTEGRATION_INITIATE
      );
      return response.data?.data as { url: string };
    } catch (error: any) {
      errorMessage(
        error?.response?.data?.responseMessage || SOME_WENT_WRONG
      );
      return rejectWithValue(
        error?.response?.data?.responseMessage || SOME_WENT_WRONG
      );
    }
  }
);

export const disconnectIntegration = createAsyncThunk(
  "integration/disconnect",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await customAxios("application/json", dispatch).delete(
        INTEGRATION_DISCONNECT
      );
      successMessage("CaleffiPricing disconnesso con successo");
      return response.data?.data;
    } catch (error: any) {
      errorMessage(
        error?.response?.data?.responseMessage || SOME_WENT_WRONG
      );
      return rejectWithValue(
        error?.response?.data?.responseMessage || SOME_WENT_WRONG
      );
    }
  }
);

export const toggleInventorySync = createAsyncThunk(
  "integration/toggleInventorySync",
  async (enabled: boolean, { rejectWithValue, dispatch }) => {
    try {
      const response = await customAxios("application/json", dispatch).patch(
        INTEGRATION_INVENTORY_SYNC,
        { enabled }
      );
      successMessage(
        enabled
          ? "Sincronizzazione inventario abilitata"
          : "Sincronizzazione inventario disabilitata"
      );
      return response.data?.data;
    } catch (error: any) {
      errorMessage(
        error?.response?.data?.responseMessage || SOME_WENT_WRONG
      );
      return rejectWithValue(
        error?.response?.data?.responseMessage || SOME_WENT_WRONG
      );
    }
  }
);

export const syncInventoryNow = createAsyncThunk(
  "integration/syncInventoryNow",
  async (_, { rejectWithValue, dispatch }) => {
    try {
      const response = await customAxios("application/json", dispatch).post(
        INTEGRATION_SYNC_NOW
      );
      successMessage(response.data?.responseMessage || "Sincronizzazione completata");
      return response.data?.data;
    } catch (error: any) {
      errorMessage(
        error?.response?.data?.responseMessage || SOME_WENT_WRONG
      );
      return rejectWithValue(
        error?.response?.data?.responseMessage || SOME_WENT_WRONG
      );
    }
  }
);
